import { Component, Input } from '@angular/core';
import { HybridPage } from '../hybrid-page/hybrid-page';
import { HybridModel } from '../../../shared/models/hybrid-model/hybrid-model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralService } from '../../../shared/services/general.service';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { WorkflowService } from '../../../shared/services/workflow.service';
import { CotStatus, WorkflowTask } from '../../../shared/models/workflow-model/workflow.model';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-task-list',
  imports: [HybridPage, TranslateModule, MatButtonModule],
  templateUrl: './task-list.html',
  styleUrl: './task-list.css',
})
export class TaskList {
  private sub: Subscription | null = null;
  public formGeneral: FormGroup = new FormGroup({});
  public formHydrid: HybridModel[] = [];
  public workflowTask: WorkflowTask[] = [];
  @Input() public quotationId: number = 0;
  @Input() cotStatus: CotStatus | null = null;

  constructor(
    private generalService: GeneralService,
    private workflowService: WorkflowService,
  ) {}

  ngOnInit() {
    this.getWorkflowTasks();

    const sub = this.generalService.subscribeForm(this.formGeneral).subscribe((value) => {
      this.toggleWorkflowInputs();
    });
    this.sub = sub;
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  public getWorkflowTasks() {
    this.workflowService
      .GetWorkflowTasks(this.quotationId, { workflowStatus: this.cotStatus?.deS_STATUS ?? null })
      .subscribe((data) => {
        if (data) {
          this.createFormHydrid(data);
          this.workflowTask = data;
        }
      });
  }

  public toggleWorkflowInputs(): void {
    for (const input of this.formHydrid) {
      if (input.key.endsWith('-checkbox')) {
        continue;
      }

      const checkboxControl = this.formGeneral.get(`${input.key}-checkbox`);
      const inputControl = this.formGeneral.get(input.key);

      if (!checkboxControl || !inputControl) {
        continue;
      }

      if (checkboxControl.value === true) {
        inputControl.enable({ emitEvent: false });
      } else {
        inputControl.disable({ emitEvent: false });
      }
    }
  }

  public createFormHydrid(workflowTask: WorkflowTask[] | null = null): FormGroup {
    if (workflowTask) {
      workflowTask.forEach((task) => {
        const inputType = () => {
          switch (task.inputTypeId) {
            case 1:
              return 'input-general-calendar';
            case 2:
              return 'input-general-text-area';
            case 3:
              return 'input-general';
            case 4:
              return 'input-general-checkbox';
            default:
              return 'input-general';
          }
        };

        this.formHydrid.push({
          control: new FormControl(task.isChecked, []),
          key: task.taskId + '-checkbox',
          label: task.taskName,
          placeholder: task.taskName,
          type: 'input-general-checkbox',
          value: task.isChecked,
        });

        this.formHydrid.push({
          control: new FormControl(task.value, [Validators.required]),
          key: `${task.taskId}`,
          label: task.taskName,
          placeholder: task.taskName,
          type: inputType(),
          disabled: !task.isChecked,
          value: task.value,
        });
      });
    }

    for (const input of this.formHydrid) {
      this.formGeneral.addControl(input.key, input.control);
    }

    this.toggleWorkflowInputs();

    return this.formGeneral;
  }

  public updateWorkflowTask() {
    const observable: Observable<any | null>[] = [];
    this.workflowTask.forEach((task) => {
      const body = {
        isChecked: this.formGeneral.get(`${task.taskId}-checkbox`)?.value ? true : false,
        quotationId: this.quotationId,
        quotationTaskId: task.quotationTaskId,
        userId: this.generalService.getUserId() ? this.generalService.getUserId()! : 0,
        value: this.formGeneral.get(`${task.taskId}`)?.value,
      };

      observable.push(this.workflowService.updateWorkflowTask(body));
    });
    return forkJoin(observable).subscribe((data) => {
      this.generalService.viewSnacAlert('Cambios guardados correctamente', 'normal', 'Guiadado');
    });
  }
}
